module.exports = __webpack_public_path__ + "img/easyupdates.9d884ab0.png";